import { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const cache = {};
const BANK_LANGS = ['en', 'de', 'it', 'es', 'nl', 'pl', 'pt', 'zh', 'tr', 'cs', 'sv', 'ru', 'ja', 'ar'];

/**
 * Page-content translation hook (15 languages).
 * Returns T(fr, en?) — fr shown for French, inline en for English when provided,
 * otherwise looked up in the AI-generated bank /i18n/pages/{lang}.json (keyed by the French string).
 */
export const usePageT = () => {
  const { language } = useLanguage();
  const [bank, setBank] = useState(cache[language] || null);

  useEffect(() => {
    if (!BANK_LANGS.includes(language)) {
      setBank(null);
      return undefined;
    }
    if (cache[language]) {
      setBank(cache[language]);
      return undefined;
    }
    let active = true;
    import(`./pages/${language}.json`)
      .then((m) => {
        cache[language] = m.default || m;
        if (active) setBank(cache[language]);
      })
      .catch(() => {});
    return () => { active = false; };
  }, [language]);

  return (fr, en) => {
    if (language === 'fr') return fr;
    if (language === 'en' && en !== undefined) return en;
    return (bank && bank[fr]) || (en !== undefined ? en : fr);
  };
};
